// 描述：错别字校对
// 作者：fanglijuan
// 时间：2017-2-24
'use strict';
angular.module('heimaCheckServiceModule', ['progressBarForHeimaCtrlModule']).factory('heimaCheckService', [
    'trsHttpService',
    '$q',
    '$modal',
    'modalDialog',
    'editIsLock',
    'ueditorService',
    'localStorageService',
    function(trsHttpService, $q, $modal, modalDialog, editIsLock, ueditorService, localStorageService) {
        // 错词级别 1：是错误， 2是疑错, 3是严重错误
        var errorLevelColor = {
            '1': '#FFA500', // 橘黄色
            '2': '#08c4c5', // 蓝色
            '3': '#FF0000', // 红色
        };
        var heimaWords = []; // 所有的黑马信息
        var localHeimaInfo; // 本地缓存的黑马信息
        
        /**
         * [getCheckField description]获取校验字段
         * @return {[obj]}  obj    [description]返回将要校验的字段（key：value）
         
        function getCheckField() {
                var checkField = {};
                $("*[heimacheck-input]").each(function(index) {
                    var modelName = $(this).attr("ng-model");
                    var checkName = modelName.split(".")[modelName.split(".").length - 1];
                    if (checkName === "APPDESC") checkName += ("*" + (parseInt($(this).attr("s-input-index")) + 1));
                    var checkValue = $(this).val();
                    var dom = document.createElement("div");
                    dom.innerHTML = checkValue;
                    checkValue = dom.innerText;
                    checkField[checkName] = checkValue;
                });
                return checkField;
        }*/
        function getCheckField() {
            var checkFieldArr = [];
            var startpos = 0;
            $('*[heimacheck-input]').each(function(index) {
                var checkField = {};
                var modelName = $(this).attr('ng-model');
                var checkName = modelName.split('.')[modelName.split('.').length - 1];
                if (checkName === 'APPDESC') {checkName += '*' + (parseInt($(this).attr('s-input-index')) + 1);}
                var checkValue = $(this).val();
                var dom = document.createElement('div');
                dom.innerHTML = checkValue;
                checkValue = dom.innerText;

                checkField.checkName = checkName;
                checkField.checkValue = checkValue;
                checkField.valueLength = checkValue.length;
                checkField.srtatPos = startpos;
                if (checkField.checkValue != '') {
                    startpos = startpos + checkField.valueLength + 4;
                    checkFieldArr.push(checkField);
                }
            });
            return checkFieldArr;
        }

        /**
         * [getAllWords description]获取校验字段对应的总信息字符串
         * @return {[type]} [description]返回校验字段对应的总信息字符串
         */
        function getAllWords() {
            var checkFields = getCheckField();
            var allWordsToStr = '';
            angular.forEach(checkFields, function(value, key) {
                if (value.checkValue != '') {
                    allWordsToStr += value.checkValue;
                }
            });
            allWordsToStr += gethtmlContent();
            return allWordsToStr;
        }

        /**
         * [getAllWordsForUpload description]获取校验字段对应的总信息字符串（*#$*分隔、拼接）
         * @return {[type]} [description]
         */
        function getAllWordsForUpload() {
            var checkFields = getCheckField();
            var allWordsForUpload = '';
            angular.forEach(checkFields, function(value, key) {
                if (value.checkValue != '') {
                    allWordsForUpload += value.checkValue + '*#$*';
                }
            });
            allWordsForUpload += gethtmlContent();
            return allWordsForUpload;
        }

        /**
         * [gethtmlContent description]获取编辑器html内容，并转为纯文本
         * @return {[type]} [description]
         */
        function gethtmlContent() {
            var htmlcontent = '';
            if (window.UE) {
                var ue = UE.getEditor('ueditor');
                htmlcontent = ue.getContent();
                htmlcontent = ueditorService.replaceHtmlBlank(htmlcontent);
                // 转为纯文本
                htmlcontent = htmlcontent
                    .replace(/<\/?[^>]*>/g, '')
                    .replace(/(&nbsp;){4}/g, '　')
                    .replace(/\&nbsp;/g, '')
                    .replace(/\&nbsp/g, '')
                    .replace(/\"/g, '"')
                    .replace(/\'/g, "'")
                    .replace(/\&quot;/g, '"')
                    .replace(/\&#39;/g, "'")
                    .replace(/\&amp;/g, '&');
            }
            return htmlcontent;
        }

        /**
         * [uploadContent description]上传待校验的内容
         * @param  {[type]} MediaType [description]渠道ID
         * @param  {[type]} DocId [description]稿件ID（除了微博渠道，其他渠道都要传此参数）
         * @param  {[type]} AccountId [description]微博账号ID（微博渠道需要传此参数）
         * @param  {[type]} content   [description]稿件的纯文本内容（可以包含标点符号）
         * @return {[type]}           [description]返回pid用于调用进度
         */
        function uploadContent(MediaType, DocId, AccountId, content) {
            var deffer = $q.defer();
            var pid = '';
            var params = {
                serviceid: 'mlf_HeiMa',
                methodname: 'uploadContent',
                content: content,
                MediaType: MediaType,
            };
            if (MediaType == 5) {
                // 微博
                params.AccountId = AccountId;
            } else {
                params.DocId = DocId;
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                pid = data;
                deffer.resolve(pid);
            });
            return deffer.promise;
        }

        /**
         * [progressBarForHeima description]获取并展示进度条
         * @param  {[type]} heimaInfo [description]
         * @return {[type]}     [description]
         */
        function progressBarForHeima(heimaInfo) {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './editingCenter/service/heimaCheck/progressBar/progressBarForHeima_tpl.html',
                windowClass: 'heimaCheck-progressBarForHeima-window',
                backdrop: false,
                controller: 'progressBarForHeimaCtrl',
                resolve: {
                    heimaInfo: function() {
                        return heimaInfo;
                    },
                },
            });
            modalInstance.result.then(
                function(result) {
                    defer.resolve(result);
                },
                function() {
                    defer.reject('cancel');
                }
            );
            return defer.promise;
        }

        /**
         * [getCheckedPointList description]获取校验结果
         * @param  {[type]} heimaInfoForResult [description]
         * @return {[type]}                    [description]
         */
        function getCheckedPointList(heimaInfoForResult) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_collatetext',
                methodname: 'getCheckedPointList',
                content: heimaInfoForResult.content,
                MediaType: heimaInfoForResult.MediaType,
                wordCount: heimaInfoForResult.wordCount,
                wordCountReal: heimaInfoForResult.wordCountReal,
                title: heimaInfoForResult.title,
                DocId: heimaInfoForResult.DocId,
            };

            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [getCheckedPointListByFuncun 未知方法用途]
         *
         * @param   {[type]}  funcunInfoForResult  [funcunInfoForResult description]
         *
         * @return  {[type]}                       [return description]
         */
        function getCheckedPointListByFuncun(funcunInfoForResult) {
            var deffer = $q.defer();
            var params = {
                serviceid: funcunInfoForResult.serviceid,
                modelid: funcunInfoForResult.modelid,
                text: funcunInfoForResult.text,
                //  error_types:funcunInfoForResult.error_types,
                strict_degree: funcunInfoForResult.strict_degree,
                typeid: 'ifuncun',
            };

            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        }

        /**
         * [dealWithHeimaWordsArr description]处理各个属性各自的黑马展示【错误信息（建议替换）：XXX】效果
         * @param  {[type]} subHeimaWordsArr [description]
         * @param  {[type]} type             [description]type：0正文；1：input框等
         * @return {[type]}                  [description]
         */
        function dealWithHeimaWordsArr(subHeimaWordsArr, type) {
            var deffer = $q.defer();
            if (subHeimaWordsArr !== '') {
                var subHeimaWordsArrToStr = [];
                angular.forEach(subHeimaWordsArr, function(item, idx) {
                    var str = item.corWord; // 建议词
                    if (str.length > 1) {
                        str = str.join('、');
                        // str = str.substring(0, str.length - 1);
                    } else {
                        str = str[0];
                    }
                    var showStrItem =
                        type == 1
                            ? "<a style='color:" + errorLevelColor[item.level] + ";'>" + item.errWord + '(' + str + ');</a>'
                            : item.errWord + '(' + str + ');';
                    if ($.inArray(showStrItem, subHeimaWordsArrToStr) == -1) {
                        subHeimaWordsArrToStr.push(showStrItem);
                    }
                });
                deffer.resolve(subHeimaWordsArrToStr);
            } else {
                deffer.resolve([]);
            }
            return deffer.promise;
        }
        
        /**
         * [replaceStrWithoutHtml description]替换黑马为带颜色标签的
         * @param  {[string]} htmlContent [description]正文
         * @param  {[string]} heimaErrorWord [description]黑马
         * @param  {[string]} replaceSpan [description]带标签的黑马
         * @return {[obj]}  obj    [description]返回黑马对象数组
         */
        function replaceStrWithoutHtml(htmlContent, heimaErrorWord, replaceSpan) {
            var str = htmlContent;
            var arry = [];
            str = str.replace(/<\/?[^>]*>/g, function(a) {
                arry.push(a);
                return '$$$___replace___***';
            });
            var reg = new RegExp(heimaErrorWord, 'gi');
            str = str.replace(reg, replaceSpan);
            var i = 0;
            str = str.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                return arry[i++];
            });
            return str;
        }

        /**
         * [markHeimaWord description]标记正文中的黑马（编辑器中）
         * @param  {[type]} htmlContent   [description]
         * @param  {[type]} heimaWords [description]最终获取到的校验结果对象数组
         * @param  {[type]} callback [回调方法]
         * @return {[type]}               [description]
         */
        function markHeimaWord(htmlContent, heimaWords, callback) {
            var heimaWordsArr = angular.copy(heimaWords);
            var htmlTagArry = [];
            var uploadContent = getAllWordsForUpload();
            htmlContent = (function() {
                var str = htmlContent;
                str = str.replace(/<\/?[^>]*>/g, function(a) {
                    htmlTagArry.push(a);
                    return '$$$___replace___***';
                });
                return str
                    .replace(/(&nbsp;){4}/g, '　')
                    .replace(/&nbsp;/g, '')
                    .replace(/&nbsp/g, '')
                    .replace(/\"/g, '"')
                    .replace(/\'/g, "'")
                    .replace(/\&quot;/g, '"')
                    .replace(/\&#39;/g, "'")
                    .replace(/\&amp;/g, '&');
            })();
            var array = uploadContent.split('*#$*');
            var length = (function() {
                var length = 0;
                for (var i = 0; i < array.length - 1; i++) {
                    length += array[i].length + 4;
                }
                return length;
            })();
            var j = heimaWordsArr.length - 1;
            while (j >= 0) {
                heimaWordsArr[j].pos -= length;
                if (heimaWordsArr[j].pos < 0) {
                    heimaWordsArr.splice(j, 1);
                }
                j--;
            }
            var startPosAdd = 0;
            var markIndex = 0; // 给错误词加上标记
            var htmlContentArray = htmlContent.split('$$$___replace___***');
            for (var k = 0; k < heimaWordsArr.length; k++) {
                var wordObj = heimaWordsArr[k];
                var errorWord = wordObj.errWord;
                var pos = (wordObj.pos += startPosAdd);
                var level = wordObj.level;
                var index = 0;
                innerloop: for (var l = 0; l < htmlContentArray.length; l++) {
                    index += htmlContentArray[l].length;
                    if (pos >= index) {
                    } else {
                        var endLocation = pos - (index - htmlContentArray[l].length) + errorWord.length;
                        var startLocation = pos - (index - htmlContentArray[l].length);
                        var otherInf = "trscheck corword='" + wordObj.corWord[0] + "' index='" + markIndex + "' level='" + level + "' ";
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(endLocation, 0, '</span>');
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(
                                startLocation,
                                0,
                                '<span ' + otherInf + "class='trasScale' style='color:" + errorLevelColor[level] + ";'>"
                            );
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        // startPosAdd += 36;
                        startPosAdd += 54 + otherInf.length; // 加了放大样式：trasScale
                        markIndex++;
                        break innerloop;
                    }
                }
            }
            htmlContent = htmlContentArray.join('$$$___replace___***');
            var m = 0;
            htmlContent = htmlContent.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                return htmlTagArry[m++];
            });
            callback(heimaWordsArr);

            /* dealWithHeimaWordsArr(heimaWordsArr, 0).then(function(data) {
                    callback(data);
                });*/
            return htmlContent;
        }

        /**
         * [markHeimaWord description]标记正文中的方寸（编辑器中）
         * @param  {[type]} htmlContent   [description]
         * @param  {[type]} heimaWords [description]最终获取到的校验结果对象数组
         * @param  {[type]} callback [description]最终获取到的校验结果对象数组
         * @return {[type]}               [description]
         */
        function markFuncunWord(htmlContent, heimaWords, callback) {
            var heimaWordsArr = angular.copy(heimaWords);
            var htmlTagArry = [];
            var uploadContent = getAllWordsForUpload();
            htmlContent = (function() {
                var str = htmlContent;
                str = str.replace(/<\/?[^>]*>/g, function(a) {
                    htmlTagArry.push(a);
                    return '$$$___replace___***';
                });
                return str
                    .replace(/(&nbsp;){4}/g, '　')
                    .replace(/&nbsp;/g, '')
                    .replace(/&nbsp/g, '')
                    .replace(/\"/g, '"')
                    .replace(/\'/g, "'")
                    .replace(/\&quot;/g, '"')
                    .replace(/\&#39;/g, "'")
                    .replace(/\&amp;/g, '&');
            })();
            var array = uploadContent.split('*#$*');
            var length = (function() {
                var length = 0;
                for (var i = 0; i < array.length - 1; i++) {
                    length += array[i].length + 4;
                }
                return length;
            })();
            var j = heimaWordsArr.length - 1;
            while (j >= 0) {
                heimaWordsArr[j].offset -= length;
                if (heimaWordsArr[j].offset < 0) {
                    heimaWordsArr.splice(j, 1);
                }
                j--;
            }
            var startPosAdd = 0;
            var markIndex = 0; // 给错误词加上标记
            var htmlContentArray = htmlContent.split('$$$___replace___***');
            for (var k = 0; k < heimaWordsArr.length; k++) {
                var wordObj = heimaWordsArr[k];
                var errorWord = wordObj.error_word;
                var pos = (wordObj.offset += startPosAdd);
                var level = wordObj.confidence;
                var index = 0;
                innerloop: for (var l = 0; l < htmlContentArray.length; l++) {
                    index += htmlContentArray[l].length;
                    if (pos >= index) {
                    } else {
                        var endLocation = pos - (index - htmlContentArray[l].length) + errorWord.length;
                        var startLocation = pos - (index - htmlContentArray[l].length);
                        var otherInf = "trscheck corword='" + wordObj.right_words[0] + "' index='" + markIndex + "' level='" + level + "' ";
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(endLocation, 0, '</span>');
                            // dataArray.splice(endLocation, 0, '（' + wordObj.type + '）</span>');
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        htmlContentArray[l] = (function(data) {
                            var dataArray = data.split('');
                            dataArray.splice(
                                startLocation,
                                0,
                                '<span ' + otherInf + "class='trasScale' style='color:" + errorLevelColor[level] + ";'>"
                            );
                            return dataArray.join('');
                        })(htmlContentArray[l]);
                        // startPosAdd += 56 + otherInf.length + wordObj.type.length; // 加了放大样式：trasScale
                        startPosAdd += 54 + otherInf.length;
                        markIndex++;
                        break innerloop;
                    }
                }
            }
            htmlContent = htmlContentArray.join('$$$___replace___***');
            var m = 0;
            htmlContent = htmlContent.replace(/\$\$\$\_\_\_replace\_\_\_\*\*\*/g, function() {
                return htmlTagArry[m++];
            });
            callback(heimaWordsArr);

            /* dealWithHeimaWordsArr(heimaWordsArr, 0).then(function(data) {
                    callback(data);
                });*/
            return htmlContent;
        }

        /**
         * [isNeedUploadCheckInfo description]是否需要进行接口请求
         * @param  {[type]}  allWords [description]
         * @return {Boolean}          [description]
         */
        function isNeedUploadCheckInfo(allWords) {
            var flag = true;
            localHeimaInfo = localStorageService.get('localHeimaInfo'); // 获取到本地错别字校对缓存信息
            if (localHeimaInfo !== null) {
                if (allWords === localHeimaInfo.content) {
                    flag = false; // 有内容相同的本地校验结果缓存
                    return localHeimaInfo;
                }
            }
            return flag;
        }

        /**
         * [excuteFangcunCheck 执行方寸校验]
         *
         * @param   {[type]}  allWords  [allWords description]
         *
         * @return  {[type]}            [return description]
         */
        function excuteFangcunCheck(allWords) {
            const defer = $q.defer();
            var funcunInfoForResult = {
                serviceid: 'article',
                modelid: 'proofread',
                text: allWords,
                error_types: '[]',
                strict_degree: 'h',
            };
            getCheckedPointListByFuncun(funcunInfoForResult).then(
                function(data) {
                    data = data.datas === '"[]"' ? [] : data.datas;
                    if (!data || data === []) {
                        defer.reject();
                        return defer.promise;
                    }
                    data.sort(function(a, b) {
                        return a.offset - b.offset;
                    });
                    if (data.length) {
                        heimaWords = getNewData(data);
                    } else {
                        heimaWords = data;
                    }
                    // 根据返回的校验结果展示校验结果：（input框，textarea文本框，正文）
                    // 并将信息存储到本地localStorage
                    localHeimaInfo = {
                        content: allWords,
                        heimaWords: heimaWords,
                    };
                    localStorageService.set('localHeimaInfo', localHeimaInfo);
                    defer.resolve(localHeimaInfo);
                },
                function() {
                    defer.reject();
                    return defer.promise;
                }
            );
            return defer.promise;
        }

        /**
         * [getNewData 过滤重复的敏感词和区间重叠的敏感词]
         *
         * @param   {[type]}  data  [data description]
         *
         * @return  {[type]}        [return description]
         */
        function getNewData(data) {
            let newArr = []; // 过滤重复敏感词后的数组
            let copyArr = []; // 过滤重复敏感词后的数组拷贝
            let newObj = {}; // 过滤重复敏感词使用的对象
            let lastArr = []; // 最终的数组
            let deleteIndex = []; // 区间重叠的自定义敏感词的索引
            while (data.length) {
                let item = data.shift();
                let key = '' + item.error_word + item.offset;
                if (!newObj[key]) {
                    newArr.push(item);
                }
                newObj[key] = item;
            }
            copyArr = JSON.parse(JSON.stringify(newArr));
            for (let i = 0; i < copyArr.length; i++) {
                const item = copyArr[i];
                const stopLocation = item.offset + item.error_word.length;
                for (let j = 0; j < newArr.length; j++) {
                    const originItem = newArr[j];
                    const originStopLocation = originItem.offset + originItem.error_word.length;
                    if (originStopLocation <= stopLocation && originItem.type === '用户自定义敏感词') {
                        deleteIndex.push(j);
                    }
                }
            }
            let index = 0;
            while (newArr.length) {
                const item = newArr.shift();
                if (deleteIndex.indexOf(index) === -1) {
                    lastArr.push(item);
                }
                index++;
            }
            return lastArr;
        }

        /**
         * [clearMarkHeimaWord description] 清除黑马标志
         * @param {string} [htmlContent] [description] 正文
         * @return {[type]} [description]
         */
        function clearMarkHeimaWord(htmlContent) {
            var dom = document.createElement('div');
            dom.innerHTML = htmlContent;
            $(dom)
                .find('span.trasScale')
                .each(function() {
                    $(this).replaceWith(this.innerHTML.replace(/\（.*\）/, ''));
                });
            return dom.innerHTML;
        }
        return {
            makeFuncunCheck: function() {
                var allWords = getAllWordsForUpload(); // 拼接后的需要校验的内容
                return excuteFangcunCheck(allWords);
            },
            // 是否进行错别字校对，提示弹窗
            isCheckHeimaWords: function(MediaType, DocId, AccountId, title, siteId, channelId) {
                var allWords = getAllWordsForUpload(); // 拼接后的需要校验的内容
                var allWordsNumber = allWords.length;
                var tureAllWordsNumner = getAllWords().length;
                var deffer = $q.defer();
                modalDialog.alertType('确认对文章进行错别字校对？', '校对字数：' + tureAllWordsNumner + '字', 'info', true, function() {
                    // 判断localStorage中是否存在
                    var result = isNeedUploadCheckInfo(allWords);
                    if (result === true) {
                        // 获取校验结果
                        var heimaInfoForResult = {
                            MediaType: MediaType,
                            DocId: DocId,
                            AccountId: AccountId,
                            wordCount: allWordsNumber,
                            wordCountReal: tureAllWordsNumner,
                            content: allWords,
                            title: title,
                            siteId: siteId,
                            channelId: channelId,
                        };
                        getCheckedPointList(heimaInfoForResult).then(function(data) {
                            data = data.result === '"[]"' ? [] : data.result;
                            data.sort(function(a, b) {
                                return a.pos - b.pos;
                            });
                            heimaWords = data;
                            // 根据返回的校验结果展示校验结果：（input框，textarea文本框，正文）
                            // 并将信息存储到本地localStorage
                            localHeimaInfo = {
                                content: allWords,
                                heimaWords: heimaWords,
                            };
                            localStorageService.set('localHeimaInfo', localHeimaInfo);
                            deffer.resolve();
                        });
                    } else {
                        heimaWords = result.heimaWords;
                        deffer.resolve();
                    }
                });
                return deffer.promise;
            },
            isCheckFuncunWords: function() {
                var allWords = getAllWordsForUpload(); // 拼接后的需要校验的内容
                var tureAllWordsNumner = getAllWords().length;
                var deffer = $q.defer();
                modalDialog.alertType('确认对文章进行错别字校对？', '校对字数：' + tureAllWordsNumner + '字', 'info', true, function() {
                    // 判断localStorage中是否存在
                    var result = isNeedUploadCheckInfo(allWords);
                    if (result === true) {
                        excuteFangcunCheck(allWords).then(() => {
                            deffer.resolve();
                        }, () => {
                            deffer.reject();
                        });
                    } else {
                        heimaWords = result.heimaWords;
                        deffer.resolve();
                    }
                });
                return deffer.promise;
            },

            /**
             * [getHeimaWordOfContent description]获取正文中的黑马
             * @param  {[type]} content [description]
             * @return {[type]}         [description]
             */
            getHeimaWordOfContent: function() {
                var deffer = $q.defer();
                deffer.resolve(heimaWords);
                return deffer.promise;
            },

            /**
             * [markHeimaWord description]标记黑马
             * @param  {[type]} htmlContent   [description]正文
             * @param  {[type]} heimaWordsArr [description]黑马数组
             * @return {[type]}               [description]标记完成的正文
             */
            markHeimaWord: function(htmlContent, heimaWordsArr, loopHandle) {
                //  return markHeimaWord(htmlContent, heimaWordsArr, loopHandle);
                return markFuncunWord(htmlContent, heimaWordsArr, loopHandle);
            },

            /**
             * [replaceStrWithoutHtml description]替换黑马为带颜色标签的
             * @param  {[type]} htmlContent    [description]正文
             * @param  {[type]} heimaErrorWord [description]黑马
             * @param  {[type]} replaceSpan    [description]带标签的黑马
             * @return {[type]}                [description]返回黑马对象数组
             */
            replaceStrWithoutHtml: function(htmlContent, heimaErrorWord, replaceSpan) {
                return replaceStrWithoutHtml(htmlContent, heimaErrorWord, replaceSpan);
            },

            /**
             * [dealWithHeimaWordsArr description]
             * @param  {[type]} subHeimaWordsArr [description]
             * @return {[type]}                  [description]
             */
            dealWithHeimaWordsArr: function(subHeimaWordsArr, type) {
                return dealWithHeimaWordsArr(subHeimaWordsArr, type);
            },

            /**
             * [getCheckField description]获取校验字段
             * @return {[type]} [description]
             */
            getCheckField: function() {
                return getCheckField();
            },

            /**
             * [markHeimaWordCompare description] 标记并比较编辑器中的错别字校对词
             * @param {object} [scope] [description] 调用区域的作用域
             * @return {[type]}    [description]
             */
            markHeimaWordCompare: function(scope) {
                var self = this;
                if (window.UE) {
                    scope.ue = UE.getEditor('ueditor');
                    initData();
                }

                /**
                 * [initData description] 初始化错别字校对
                 * @return {[type]} [description]
                 */
                function initData() {
                    var htmlcontent = scope.ue.getContent();

                    markHeimaWord(htmlcontent);
                }

                /**
                 * [markHeimaWord description] 在编辑器中标记命中词
                 * @return {[type]} [description]
                 */
                function markHeimaWord() {
                    var htmlContent = scope.ue.getContent();
                    if (htmlContent !== '') {
                        htmlContent = ueditorService.replaceHtmlBlank(htmlContent);
                        self.getHeimaWordOfContent().then(function(heimaWordsArr) {
                            scope.heimaWordsArr = heimaWordsArr;
                            scope.subHeimaWordsArr = [];

                            /* $scope.subHeimaWordsArrToStr = [];*/
                            // 构造标红元素
                            htmlContent = self.markHeimaWord(htmlContent, heimaWordsArr, function(value) {
                                //  var arr = Array.from(new Set(value));
                                var arr = value;
                                for (let i = 0; i < arr.length; i++) {
                                    let item = arr[i];
                                    arr[i].advise = !!item.right_words[0] ? item.right_words[0] : item.type;
                                }
                                scope.subHeimaWordsArr = arr;
                            });
                            scope.ue.setContent(htmlContent);
                        });
                    }
                }
            },

            /**
             * [leaveCheckoutMode description] 编辑器退出校验模式
             * @param  {[object]} scope      [description] 调用区域的作用域
             * @return {[type]} [description]
             */
            leaveCheckoutMode: function(scope) {
                if (window.UE && scope) {
                    let ue = UE.getEditor('ueditor');
                    var htmlContent = ue.getContent();
                    htmlContent = clearMarkHeimaWord(htmlContent);
                    ue.setContent(htmlContent);
                }
            },
        };
    },
]);
